import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { fetchClients } from "../../Apis/Wallet-api";
import Layout4 from "../DataLayouts/Layout4";

export default function WalletClientsList() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [clients, setClients] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const rows = await fetchClients();
      setClients(Array.isArray(rows) ? rows : []);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load clients.");
      setClients([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1200 }}>
      <Layout4
        heading="Clients"
        subtitle="Platform tenants with API credentials for system integrations"
        showAddButton={false}
      />

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress size={32} />
        </Box>
      ) : clients.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: "center" }}>
          <Typography color="text.secondary">No clients yet.</Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>API key</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Agents</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clients.map((c) => (
                <TableRow
                  key={c.client_id}
                  hover
                  sx={{ cursor: "pointer" }}
                  onClick={() => navigate(`/wallet/clients/${c.client_id}`)}
                >
                  <TableCell>{c.client_id}</TableCell>
                  <TableCell>{c.client_name}</TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      fontFamily="monospace"
                      sx={{
                        maxWidth: 180,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {c.api_key || "—"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={c.is_active === false ? "inactive" : "active"}
                      color={c.is_active === false ? "default" : "success"}
                    />
                  </TableCell>
                  <TableCell align="right">{c.agent_count ?? 0}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
